import React from 'react';
import { FadeIn } from './FadeIn';
import { Heart } from 'lucide-react';
export function CTASection() {
  return <section className="pt-24 pb-10 px-6 bg-sage text-center relative overflow-hidden" data-id="element-9">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-10"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-11">
        <FadeIn data-id="element-12">
          <Heart className="w-12 h-12 text-cream mx-auto mb-8 opacity-80" data-id="element-13" />
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-cream mb-8 leading-tight" data-id="element-14">
            Mereces despertar sintiéndote bien.
          </h2>
          <p className="text-xl text-cream/90 mb-12 font-serif italic" data-id="element-15">
            Existe una forma más amable con tu cuerpo para recuperar tu
            bienestar.
          </p>

          <a href="https://horizontevital.org/cart/47720679276698:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-cream text-brown hover:bg-white px-10 py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer" data-id="element-16">
            Descargar 7 Días Alivio Integral Para el Dolor Articular
          </a>
        </FadeIn>
      </div>
    </section>;
}